export default __webpack_public_path__ + "static/media/magnifying-glass.84fbe2d6.svg";